/* $(function(){
    $('.hex-row-wrapper').each(function(){  
      var highestBox = 0;
      $('.hex-col', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      });  
      $('.hex-col',this).height(highestBox);
    }); 
}); */
